import moment from 'moment-es6'

const DateFormat = {
  filters: {
    date (value) {
      return moment(value).format('DD/MM/YYYY')
    },
    time (value) {
      return moment(value).format('DD/MM/YYYY HH:mm')
    },
    nullableTime (value) {
      if (!value || value == null) {
        return 'In progress...'
      }
      return moment(value).format('DD/MM/YYYY HH:mm')
    }
  }
}

export default DateFormat



// WEBPACK FOOTER //
// ./src/mixins/DateFormat.js